import React, { Component } from 'react'

import {
    Card, CardContent, CardHeader, Checkbox, Typography, Button, List, ListItemButton, ListItemText,
    Grid,
    IconButton,
    LinearProgress,
    Box
} from '@mui/material'
import { ListItem } from 'react-bootstrap/lib/Media';
import SFLineChart2 from './SFLineChart2';
import { TbTargetArrow } from 'react-icons/tb';
import { IoTimerSharp } from 'react-icons/io5';
import SFTable from './SFTable';
import { PiCaretCircleDown, PiCaretCircleUp } from 'react-icons/pi';
import moment from 'moment';
import SFBarChart from './SFBarChart';
import ApiRequestService from '../ApiRequestService';
import LoadingSpinner from '../LoadingSpinner';

let colors = [
    "#74ADE4",
    "#3FB68E",
    "#ED8D61",
    "#F36A94",
    "#AA7ED7",
    "#3DB5C5",
]

const defaultColumns = [
    {
        id: 'expand',
        name: 'Expand',
        width: "50px",
        visible: false,
    },
    {
        id: 'name',
        name: 'Category Name',
        width: "300px",
    },
    {
        id: 'accuracy',
        name: 'Accuracy %',
        width: "200px",
    },
    {
        id: 'time',
        name: 'Total Time',
        width: "200px",
    },
    {
        id: 'actions',
        name: 'Add to Practice set',
        width: "100px",
        center: true
    },
]
class SFTopicDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
            topics: [],
            selectedTopic: null,
            loading: false,
            topics: [],
            categories: [],
            selectedCatIndex: 0,
            columns: [...defaultColumns],
        };
    }

    componentDidMount() {
        this.props.handleUpdateCount(0);
        this.getByTopics();
        this.updateColumns();
    }

    updateColumns = () => {
        let updatedColumns = defaultColumns.map(col => ({ ...col }));
        if (this.props.selectedStudentUserName) {
            updatedColumns.pop();
        }
        if (this.props.selectedStudentUserName === "all") {
            updatedColumns[2].name = "Mean Accuracy %";
            let colThree = updatedColumns[3];
            updatedColumns[3] = {
                id: 'accuracy_index',
                name: 'Mean Accuracy Index',
                width: "200px",
            };
            colThree.name = "Median Time";
            updatedColumns[4] = colThree;
            console.debug("updatedColumns", updatedColumns)
        }
        this.setState({
            columns: updatedColumns
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedCourse?.course_id !== this.props.selectedCourse?.course_id
            || prevProps.selectedStudentUserName !== this.props.selectedStudentUserName) {
            this.getByTopics();
            this.updateColumns();
        }
    }

    getByTopics = () => {
        if (this.props.selectedStudentUserName === "all" &&
            this.props.savedTopicsForAllStudents && this.props.savedTopicsForAllStudents.length) {
            let firstTopic = this.props.savedTopicsForAllStudents[0];
            this.setState({
                topics: this.props.savedTopicsForAllStudents,
                selectedTopic: firstTopic,
                categories: firstTopic.categoryAnalytic ? firstTopic.categoryAnalytic : [],
            })
            this.props.handleUpdateCount(this.props.savedTopicsForAllStudents.length);
            return;
        }

        this.setState({
            loading: true,
        })

        let payload = {
            courseID: this.props.selectedCourse.course_id,
            sectionID: this.props.selectedInstructorSectionID,
            userName: this.props.selectedStudentUserName,
        }
        if (this.props.selectedStudentUserName === "all") {
            payload.allStudents = true
        }

        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getByTopics",
            data: payload
        });

        responsePromise
            .then((res) => {
                let count = 0;
                if (res && res.data && res.data.data) {
                    let topics = res.data.data;
                    this.setState({
                        topics: topics,
                    })
                    if (payload.userName === "all") {
                        let key = `${this.props.selectedCourse.course_id}_${this.props.selectedCourse.section_id}`;
                        this.props.updateSavedTopicsForAllStudents(key, topics)
                    }
                    count = topics.length;
                    if (topics && topics.length) {
                        let firstTopic = topics[0];
                        let categories = firstTopic.categoryAnalytic ? firstTopic.categoryAnalytic : [];
                        if (categories && categories.length) {
                            categories[0].expand = true;
                        }
                        this.setState({
                            selectedTopic: firstTopic,
                            categories: categories,
                        })
                    }
                } else {
                    this.setState({
                        topics: [],
                        selectedTopic: null,
                        categories: []
                    })
                    count = 0;
                }
                this.props.handleUpdateCount(count);
            })
            .catch((error) => {
                console.error("Error when getting Student Dashboard Data", error);
            })
            .finally(() => {
                this.setState({
                    loading: false
                })
            });
    }


    handleAddToPractice = (catData, index) => {
        this.props.handleAddCategory(catData);

        let logPayload = {
            toNomenclatureID: 5, // 6-checked
            subjectID: catData.subjectID,
            topicID: catData.topicID,
            categoryID: catData.categoryID,
            activityTypeID: 17, // "Category" activity in p&p page
        };

        if (this.props.onAddActivityLog) {
            this.props.onAddActivityLog(logPayload)
        }

    }

    handleRemovFromPractice = (catData, index) => {
        this.props.handleRemoveCategory(catData);

        let logPayload = {
            toNomenclatureID: 6, // 6-unchecked
            subjectID: catData.subjectID,
            topicID: catData.topicID,
            categoryID: catData.categoryID,
            activityTypeID: 17, // "Category" activity in p&p page
        };

        if (this.props.onAddActivityLog) {
            this.props.onAddActivityLog(logPayload)
        }

    }

    renderRow(data, index, isInstructor, renderRowProps) {

        let categories = this.dataArr;

        function getReadableTime(timeInSec) {
            if (timeInSec <= 60) {
                return `${timeInSec} sec`
            }
            let min = moment.duration(timeInSec, 'seconds').minutes()
            let sec = moment.duration(timeInSec, 'seconds').seconds()

            return `${min}m ${sec}s`
        }


        function getLabelsMaxCount() {
            let count = 0;

            if (categories && categories.length) {
                categories.forEach(cat => {
                    let l = cat?.categoryPracticeDataArr && cat?.categoryPracticeDataArr ? cat.categoryPracticeDataArr.length : 0;
                    if (l > count) {
                        count = l;
                    }
                })
            }

            return count;
        }

        let catKey = `${data.subjectID}_${data.topicID}_${data.categoryID}`
        let catIsAlreadyAdded = false;
        if (this.selectedCategories && this.selectedCategories.length) {
            this.selectedCategories.forEach(selectedCat => {
                if (`${selectedCat.subjectID}_${selectedCat.topicID}_${selectedCat.categoryID}` === catKey) {
                    catIsAlreadyAdded = true;
                }
            });
        }

        let latestTime = 0;
        let latestAccuracyIndex = 0;
        let latestAccuracyPercent = 0;

        if (data && data.categoryPracticeDataArr && data.categoryPracticeDataArr.length) {
            let l = data.categoryPracticeDataArr.length;
            let lastData = data.categoryPracticeDataArr[l - 1];
            if (lastData) {
                latestTime = lastData.time;
                latestAccuracyPercent = lastData.accuracyPercent;
                latestAccuracyIndex = lastData.accuracy;
            }
        }


        return (
            <div>
                <div className='sf-table-row cursor-pointer'
                    style={{
                        overflowY: 'auto',
                        height: renderRowProps.selectedStudentUserName === "all" ? "calc(100% - 65px)" : "100%",
                    }}
                    onClick={(event) => {
                        if (event.target && event.target.type === "checkbox") return;
                        this.handleExpand(index)
                    }}>
                    <div className='sf-table-row-div' style={{ width: this.columns[0].width }}>
                        <IconButton>
                            {data.expand ?
                                <PiCaretCircleDown fontSize={24} color='#333' />
                                : <PiCaretCircleUp fontSize={24} color='#333' />}
                        </IconButton>
                    </div>
                    <div className='sf-table-row-div' style={{ width: this.columns[1].width, justifyContent: "start" }}>
                        {data.name}
                    </div>
                    <div className='sf-table-row-div' style={{ width: this.columns[2].width }}>
                        <div className='w-100 h-100 text-align-center'>
                            <div>{latestAccuracyPercent}%</div>
                            <div>
                                <LinearProgress
                                    style={{ height: '8px', borderRadius: '75px' }}
                                    variant="determinate" value={latestAccuracyPercent} />
                            </div>
                        </div>
                    </div>
                    {renderRowProps.selectedStudentUserName === "all" ?
                        <div className='sf-table-row-div' style={{ width: '200px' }}>
                            <div className='w-100 h-100 text-align-center'>
                                <div>{latestAccuracyIndex}%</div>
                                <div>
                                    <LinearProgress
                                        style={{ height: '8px', borderRadius: '75px' }}
                                        variant="determinate" value={latestAccuracyIndex} />
                                </div>
                            </div>
                        </div>
                        : null}
                    <div className='sf-table-row-div' style={{ width: this.columns[3].width }}>
                        <div className='text-center' style={{ color: '#0F7C27' }}>
                            <div className='fontClass-22'>
                                {getReadableTime(latestTime)}
                            </div>
                            <div>{data.speed_message}</div>
                        </div>
                    </div>
                    {renderRowProps.selectedStudentUserName ? null :
                        <div className='sf-table-row-div' style={{ width: this.columns[4] ? this.columns[4].width : "" }}>
                            <Checkbox
                                style={{
                                    zIndex: '99 !important'
                                }}
                                disabled={isInstructor}
                                id={catKey}
                                checked={catIsAlreadyAdded}
                                onChange={(event) => {

                                    let value = event.target.checked;
                                    if (value) {
                                        this.handleAddToPractice(data, index)
                                    } else {
                                        this.handleRemovFromPractice(data, index)
                                    }

                                }}
                            />
                        </div>
                    }
                </div>

                <div style={{
                    display: data.expand ? "block" : 'none'
                }}>
                    <Box style={{
                        height: '400px',
                        width: '100%',
                        background: 'white',
                        marginTop: "-8px",
                        gap: "2rem",
                    }} className="d-flex justify-content-center align-items-center">
                        {renderRowProps.selectedStudentUserName === "all" ?
                            <>
                                <SFBarChart
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600}>
                                                    <TbTargetArrow fontSize={22} />
                                                    Mean Accuracy %
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    forAllStudent={true}
                                    format="%"
                                    type={"linear"}
                                    xAxisLabel={"Quizzes"}
                                    yAxisLabel={"Mean Accuracy %"}
                                    isPractice={false}
                                    // labels={data?.categoryPracticeDataArr ? data?.categoryPracticeDataArr.map((_, index) => index + 1) : []}
                                    labels={data?.categoryPracticeDataArr ? data?.categoryPracticeDataArr.map(cat => cat.quizName) : []}
                                    dataArr={data?.categoryPracticeDataArr ? data?.categoryPracticeDataArr.map(cat => cat.accuracyPercent) : []}
                                    practiceDataArr={[]}
                                    xmin={0}
                                    min={0}
                                    max={100}
                                    stepSize={20}
                                />
                                <SFBarChart
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600}>
                                                    <TbTargetArrow fontSize={22} />
                                                    Mean Accuracy Index
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    forAllStudent={true}
                                    format="%"
                                    type={"linear"}
                                    xAxisLabel={"Quizzes"}
                                    yAxisLabel={"Mean Accuracy Index"}
                                    isPractice={false}
                                    // labels={data?.categoryPracticeDataArr ? data?.categoryPracticeDataArr.map((_, index) => index + 1) : []}
                                    labels={data?.categoryPracticeDataArr ? data?.categoryPracticeDataArr.map(cat => cat.quizName) : []}
                                    dataArr={data?.categoryPracticeDataArr ? data?.categoryPracticeDataArr.map(cat => cat.accuracy) : []}
                                    practiceDataArr={[]}
                                    xmin={0}
                                    min={0}
                                    max={100}
                                    stepSize={20}
                                />
                                <SFBarChart
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600}>
                                                    <IoTimerSharp fontSize={22} />

                                                    {renderRowProps.selectedStudentUserName === "all" ? "Median Time Taken (min)" : "Time Taken (min)"}
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    forAllStudent={true}
                                    format="m"
                                    type={"logarithmic"}
                                    xAxisLabel={"Quizzes"}
                                    yAxisLabel={renderRowProps.selectedStudentUserName === "all" ? "Median Time Take (min)" : "Time Take (min)"}
                                    isPractice={false}
                                    // labels={data?.categoryPracticeDataArr ? data?.categoryPracticeDataArr?.map((_, index) => index + 1) : []}
                                    labels={data?.categoryPracticeDataArr ? data?.categoryPracticeDataArr.map(cat => cat.quizName) : []}
                                    dataArr={data?.categoryPracticeDataArr ? data?.categoryPracticeDataArr?.map(cat => {
                                        return parseFloat((cat.time / 60).toFixed(1))
                                    }) : []}
                                    practiceDataArr={[]}
                                    xmin={0}
                                    min={0}
                                    max={0}
                                    stepSize={1}
                                />
                            </>
                            : <>
                                <SFLineChart2
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600}>
                                                    <TbTargetArrow fontSize={22} /> Accuracy
                                                    {renderRowProps.selectedStudentUserName === "all" ? "Mean Accuracy" : "Accuracy"}
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    format="%"
                                    type={"linear"}
                                    xAxisLabel={"Attempts #"}
                                    yAxisLabel={renderRowProps.selectedStudentUserName === "all" ? "Mean Accuracy %" : "Accuracy %"}
                                    labelsMaxCount={getLabelsMaxCount()}
                                    tootltipLabel="Accuracy"
                                    //labelsArr={data?.categoryPracticeDataArr?.map((cp, index) => `${cp.quizName}`)}
                                    dataArr={data?.categoryPracticeDataArr?.map((cp, index) => cp.accuracyPercent)}
                                    min={0}
                                    max={100}
                                    stepSize={20}
                                />
                                <SFLineChart2
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600}>
                                                    <IoTimerSharp fontSize={22} />
                                                    {renderRowProps.selectedStudentUserName === "all" ? "Median Time Taken (min)" : "Time Taken (min)"}
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    format="%"
                                    type={"logarithmic"}
                                    xAxisLabel={"Attempts #"}
                                    yAxisLabel={renderRowProps.selectedStudentUserName === "all" ? "Median Time Take (min)" : "Time Take (min)"}
                                    labelsMaxCount={getLabelsMaxCount()}
                                    tootltipLabel="Time"
                                    //labelsArr={data?.categoryPracticeDataArr?.map((cp, index) => cp.quizName)}
                                    dataArr={data?.categoryPracticeDataArr?.map((cp, index) => parseFloat((cp.time / 60).toFixed(1)))}
                                    min={0}
                                    max={100}
                                    stepSize={10}
                                />
                            </>}


                    </Box>
                </div>

                <div className='justify-content-center align-items-center pb-4 pt-3' style={{
                    gap: "2rem",
                    display: data.expand ? "flex" : 'none',
                    background: "#fff",
                }}>
                    {/* <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#0077B9", width: "30px", height: "7px" }}></div>
                        Graded
                    </div> */}
                    {/* <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#FF5287", width: "30px", height: "7px" }}></div>
                        Practice
                    </div>
                    <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#D6AAAC", width: "30px", height: "7px", borderRadius: "15px" }}></div>
                        Goal
                    </div> */}
                </div>

            </div>
        )
    }

    handleExpand = (index) => {
        let value = this.state.categories[index].expand !== undefined ? !this.state.categories[index].expand : true;
        let updatedData = {
            ...this.state.categories[index],
            expand: value,
        }
        let updatedCategories = [...this.state.categories];
        updatedCategories[index] = updatedData;


        this.setState({
            categories: updatedCategories
        })

        const activityPayload = {
            toNomenclatureID: value ? 1 : 2,
            subjectID: updatedData.subjectID,
            topicID: updatedData.topicID,
            categoryID: updatedData.categoryID,
            activityTypeID: 17, // "Topic"
        }
        if (this.props.onAddActivityLog) {
            this.props.onAddActivityLog(activityPayload);
        }
    }

    render() {

        const { topics, selectedTopic, categories, selectedCatIndex, loading } = this.state;

        if (loading) {
            return (
                <div className='sf-fixed-center'>
                    <LoadingSpinner loading={true} />
                </div>
            );
        }

        if (topics === null || topics === undefined || topics?.length === 0) {
            return (
                <div className='sf-fixed-center'>
                    <Typography fontSize={24} fontWeight={500}>
                        No Data Found.
                    </Typography>
                </div>
            )
        }

        // return "No Data Found."
        return (
            <Grid container spacing={2} className='sf-pa-gird'>
                <Grid item md={2}
                    className='sf-assig-list p-0 mt-3 pl-4'
                    style={{
                        // height: this.props.selectedStudentUserName === "all" ? "calc(100% - 65px)" : "100%",
                        height: "100vh",
                    }}
                >
                    <Card className='pr-3 pr-2 overflow-auto'
                        style={{
                            // height: this.props.selectedStudentUserName === "all" ? "calc(100% - 65px)" : "100%",
                            height: "100vh",
                        }}
                    >
                        <Typography className='py-2' textAlign={'center'} fontSize={16} fontWeight={700}>
                            Topic Name
                        </Typography>
                        {topics.map((topic, index) => {
                            return (
                                <ListItem key={index} 
                                style={{
                                        listStyle: 'none'
                                    }}
                                className={`
                                    ${selectedTopic?.key === topic.key ? "pa-assignment-selected " : " "}

                                    pa-assignment mb-1
                                `}
                                    onClick={() => {
                                        this.setState({
                                            selectedTopic: topic,
                                            categories: topic.categoryAnalytic ? topic.categoryAnalytic : [],
                                        })

                                        let logPayload = {
                                            toNomenclatureID: 0, // clicked
                                            subjectID: topic.subjectID,
                                            topicID: topic.topicID,
                                            categoryID: 0,
                                            activityTypeID: 17, // "Topic" activity in p&p page
                                        };

                                        if (this.props.onAddActivityLog) {
                                            this.props.onAddActivityLog(logPayload);
                                        }
                                    }}
                                >
                                    <ListItemText>{topic.name}</ListItemText>
                                </ListItem>
                            )
                        })}
                    </Card>
                </Grid>
                <Grid item
                    md={10}
                    className='sf-pa-list'>
                    <div style={{ width: "100%", height: '100%' }}>
                        <div className='d-flex justify-content-start align-items-center mb-2'
                            style={{
                                gap: '1rem'
                            }}>
                            <div>
                                <Typography fontSize={30} fontWeight='bold'>
                                    {selectedTopic?.name}
                                </Typography>
                            </div>
                        </div>

                        {/* Category Table */}
                        <div className='mt-0 w-100 position-relative'
                            style={{
                                height: this.props.selectedStudentUserName === "all" ? "calc(100% - 65px)" : "calc(100% - 45px)"
                            }}
                        >
                            <SFTable
                                columns={this.state.columns}
                                dataArr={this.state.categories || null}
                                renderRow={this.renderRow}
                                isInstructor={this.props.isInstructor}
                                handleExpand={this.handleExpand}
                                handleAddToPractice={this.handleAddToPractice}
                                handleRemovFromPractice={this.handleRemovFromPractice}
                                selectedCategories={this.props.selectedCategories}
                                selectedTopic={selectedTopic}
                                onAddActivityLog={this.props.onAddActivityLog}
                                selectedCatIndex={this.state.selectedCatIndex}
                                selectedStudentUserName={this.props.selectedStudentUserName}
                            /*
                            handleAddToPractice={this.handleAddToPractice}
                            handleRemovFromPractice={this.handleRemovFromPractice}
                            selectedCategories={this.props.selectedCategories} */
                            />
                        </div>

                    </div>
                    {/* <Card style={{
                        height: '100%',
                        overflow: 'auto'
                    }}>
                        <CardHeader title={
                            <div>
                                <Typography fontSize={30} fontWeight={500}>
                                    <strong>{selectedTopic?.name}</strong>
                                </Typography>
                                <Typography>Total no. of Categories ({selectedTopic?.categoryAnalytic.length})</Typography>
                            </div>
                        }></CardHeader>
                        <CardContent>
                            <div className='d-flex justify-content-center mb-5' style={{ gap: '2rem' }}>
                                <SFLineChart2
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600}>
                                                    <TbTargetArrow fontSize={22} /> Accuracy
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    format="%"
                                    type={"linear"}
                                    xAxisLabel={"Attempts #"}
                                    yAxisLabel={"Accuracy %"}
                                    selectedDataArr={categories && categories.length ?
                                        categories[selectedCatIndex].categoryPracticeDataArr?.map(cp => cp.accuracyPercent)
                                        : []}
                                    labelsMaxCount={this.getLabelsMaxCount()}
                                    dataArr={categories?.map((cat, index) => {
                                        let mainData = {
                                            data: cat?.categoryPracticeDataArr?.map(cp => cp.accuracyPercent),
                                            borderColor: colors[index],
                                            borderWidth: 8,
                                            pointRadius: 1,
                                            pointBorderWidth: selectedCatIndex === index ? 4 : 0,
                                            pointBorderColor: '#333',
                                            pointStyle: selectedCatIndex === index ? 'circle' : false,
                                            order: selectedCatIndex === index ? 1 : 3,
                                            datalabels: {
                                                display: selectedCatIndex === index ? true : false,
                                                color: 'white',
                                                backgroundColor: '#222',
                                                borderRadius: 15,
                                                padding: {
                                                    top: 2,
                                                    right: 4,
                                                    bottom: 2,
                                                    left: 4,
                                                },
                                                anchor: 'end',
                                                align: 'right',
                                                font: {
                                                    weight: 'bold',
                                                },
                                                formatter: (value) => {
                                                    return `${value}%`
                                                }
                                            },
                                        }

                                        return mainData;
                                    })}
                                    min={0}
                                    max={100}
                                    stepSize={20}
                                />
                                <SFLineChart2
                                    title={
                                        <div className='pl-5'>
                                            <center>
                                                <Typography fontSize={14} fontWeight={600}>
                                                    <IoTimerSharp fontSize={22} /> Time Taken (sec)
                                                </Typography>
                                            </center>
                                        </div>
                                    }
                                    format="%"
                                    type={"logarithmic"}
                                    xAxisLabel={"Attempts #"}
                                    yAxisLabel={"Time In (sec)"}
                                    selectedDataArr={categories && categories.length ?
                                        categories[selectedCatIndex].categoryPracticeDataArr?.map(cp => cp.time)
                                        : []}
                                    labelsMaxCount={this.getLabelsMaxCount()}
                                    dataArr={categories?.map((cat, index) => {
                                        let mainData = {
                                            data: cat?.categoryPracticeDataArr?.map(cp => cp.time),
                                            borderColor: colors[index],
                                            borderWidth: 8,
                                            pointRadius: 1,
                                            pointBorderWidth: selectedCatIndex === index ? 4 : 0,
                                            pointBorderColor: '#333',
                                            pointStyle: selectedCatIndex === index ? 'circle' : false,
                                            order: selectedCatIndex === index ? 1 : 3,
                                            datalabels: {
                                                display: selectedCatIndex === index ? true : false,
                                                color: 'white',
                                                backgroundColor: '#222',
                                                borderRadius: 15,
                                                padding: {
                                                    top: 2,
                                                    right: 4,
                                                    bottom: 2,
                                                    left: 4,
                                                },
                                                anchor: 'end',
                                                align: 'right',
                                                font: {
                                                    weight: 'bold',
                                                },
                                                formatter: (value) => {
                                                    return ` ${value}s `
                                                }
                                            },
                                        }

                                        return mainData;
                                    })}
                                    min={0}
                                    max={100}
                                    stepSize={10}
                                />
                            </div>
                            <div className='mt-5 ml-4'>
                                <Typography fontWeight={'700'}>CATEGORIES</Typography>
                                <div className='sf-pa-topic-cat-list'>
                                    {categories?.map((cat, index) => {
                                        let latestTime = 0;
                                        if (cat && cat.categoryPracticeDataArr && cat.categoryPracticeDataArr.length) {
                                            let l = cat.categoryPracticeDataArr.length;
                                            let lastData = cat.categoryPracticeDataArr[l - 1];
                                            if (lastData) {
                                                latestTime = lastData.time;
                                            }
                                        }
                                        return (
                                            <div className='sf-pa-topic-cat' key={index}>
                                                <div className='sf-pa-topic-cat-left cursor-pointer' onClick={() => {
                                                    this.setState({
                                                        selectedCatIndex: index,
                                                    })
                                                }}>
                                                    <div className='chip' style={{
                                                        background: colors[index] ? colors[index] : colors[0],
                                                        border: "2px solid",
                                                        borderColor: selectedCatIndex === index ? "#333" : colors[index]
                                                    }}></div>
                                                    <Typography fontWeight={selectedCatIndex === index ? 800 : 400}>
                                                        {cat.name} ({latestTime} Sec)
                                                    </Typography>
                                                </div>
                                                <div className='sf-pa-topic-cat-right'>
                                                    <div className='line'></div>
                                                    <Checkbox />
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                            <div className='d-flex justify-content-between align-items-center' style={{
                            }}>
                                <div className='mt-2 ml-4'>
                                    Note: Select the check box to “Add categories to Practice Set“
                                </div>
                                <div className='float-right'>
                                    <Button variant='outlined'>Add to Practice Set</Button>
                                </div>
                            </div>
                        </CardContent>
                    </Card> */}

                </Grid>
            </Grid>
        )
    }
}

export default SFTopicDetail;